import { useState, useContext, Fragment } from "react";
// @mui material components
import { Card, CircularProgress } from "@mui/material";
import { Error } from "@mui/icons-material";
// Material Dashboard 2 React components
import BTBox from "../../components/BTBox";
import BTTypography from "../../components/BTTypography";
import BTInput from "../../components/BTInput";
import BTButton from "../../components/BTButton";
// Authentication layout component
import { AuthContext } from "../../context";
// Images
import bgImage from "../../assets/images/sign-in.jpeg";
import CoverLayout from "../components/CoverLayouts";
import authService from "../../services/auth-service";
import { useNotification } from "../../context";
function Basic() {
  const { login } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    u_email: "",
    u_password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();
  const validation = (data) => {
    const { u_email, u_password } = data;
    const errors = {};
    const addError = (field, message) => (errors[field] = message);
    if (!u_email?.trim()) {
      addError("u_email", "Email address is required");
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(u_email)) {
      addError("u_email", "Invalid email format");
    }
    if (!u_password?.trim()) {
      addError("u_password", "Password is required");
    }
    return Object.keys(errors).length > 0 ? errors : {};
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const newErrors = validation({ ...formData, [name]: value });
    if (Object.keys(newErrors).length === 0) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...rest } = prevErrors;
        return rest;
      });
    } else {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: newErrors[name] || null,
      }));
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validation(formData);
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      try {
        await new Promise((resolve) => setTimeout(resolve, 1000));
        const response = await authService?.login({ attributes: formData });
        login(response);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        addNotification({
          icon: <Error color="white" />,
          title: "Error!",
          message: error?.response?.data?.message || "Something went to wrong",
          color: "error",
        });
      }
    }
  };

  return (
    <CoverLayout image={bgImage}>
      <Card sx={{ overflow: "visible", borderRadius: "10px" }}>
        <BTBox
          variant="gradient"
          bgColor="dark"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          p={1}
          textAlign="center"
          position="relative"
          bottom={"45px"}
        >
          <BTTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </BTTypography>
          <BTTypography display="block" variant="body2" color="white" my={1}>
            Enter your email and password to Sign in
          </BTTypography>
        </BTBox>
        <BTBox pb={3} px={3}>
          <BTBox component="form" role="form" onSubmit={handleSubmit}>
            <BTBox mb={2}>
              <BTInput
                type="email"
                name="u_email"
                label="Email"
                value={formData?.u_email}
                onChange={handleChange}
                fullWidth
                variant="standard"
                error={!!errors.u_email}
                helperText={errors.u_email}
              />
            </BTBox>
            <BTBox mb={2}>
              <BTInput
                type="password"
                label="Password"
                name="u_password"
                value={formData?.u_password}
                onChange={handleChange}
                fullWidth
                variant="standard"
                error={!!errors.u_password}
                helperText={errors.u_password}
              />
            </BTBox>
            <BTBox mt={4} mb={1}>
              <BTButton
                variant="gradient"
                color="dark"
                type="submit"
                sx={{ p: 0 }}
                fullWidth
              >
                {loading ? (
                  <Fragment>
                    <svg width={0} height={0}>
                      <defs>
                        <linearGradient
                          id="my_gradient"
                          x1="0%"
                          y1="0%"
                          x2="0%"
                          y2="100%"
                        >
                          <stop offset="0%" stopColor="#e01cd5" />
                          <stop offset="100%" stopColor="#1CB5E0" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <CircularProgress
                      size={25}
                      sx={{
                        "svg circle": { stroke: "url(#my_gradient)" },
                      }}
                    />
                  </Fragment>
                ) : (
                  "sign in"
                )}
              </BTButton>
            </BTBox>
            {/* <BTBox mt={3} mb={1} textAlign="center">
              <BTTypography variant="body2" color="text">
                Don&apos;t have an account?{" "}
                <BTTypography
                  component={Link}
                  to="/sign-up"
                  variant="button"
                  color="black"
                  fontWeight="medium"
                  textGradient
                >
                  Sign up
                </BTTypography>
              </BTTypography>
            </BTBox> */}
          </BTBox>
        </BTBox>
      </Card>
    </CoverLayout>
  );
}

export default Basic;
